import * as React from "react";
import {SelectInput, SelectInputOption} from "@vebox/etui-core";
import {
    Actions,
    ActionsEnum,
    CensusEquipmentStatusDetailsEnum,
    CensusEquipmentStatusesEnum,
} from "../../data/models/CensusEnums";
import {getActionOptions} from "../SuggestedActionsTable/utils";
import {Div} from "@vebox/etui-system-elements";
import {JSONCensusEquipmentsActionsConfirmation} from "../../data/models/JSONCensusEquipmentsActionsConfirmation";
import {AppTranslations} from "../../../../../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;

interface GlobalSuggestedActionProps {
    suggestedAction: ActionsEnum;
    isMixedActionSelected: boolean;
    mergeConfirmedActions: (
        action: JSONCensusEquipmentsActionsConfirmation,
        isMixedActionSelected?: boolean,
    ) => void;
    status: CensusEquipmentStatusesEnum;
    statusDetail?: CensusEquipmentStatusDetailsEnum;
    confirmedAction?: JSONCensusEquipmentsActionsConfirmation;
    availableActions: ActionsEnum[],
    translatedActionsEnum: Actions;
}

const getSuggestedOption = (
    actions: Actions,
    suggestedAction: ActionsEnum,
): SelectInputOption => {
    return actions
        ? {
            value: suggestedAction,
            label: suggestedAction === ActionsEnum.MULTIPLE_SELECTIONS
                ? AppTranslations.massiveActions.censusCooler.multipleActions
                : actions?.[suggestedAction] ?? suggestedAction,
        }
        : null;
};

export const GlobalSuggestedAction: React.FC<GlobalSuggestedActionProps> = ({
                                                                                translatedActionsEnum,
                                                                                suggestedAction,
                                                                                isMixedActionSelected,
                                                                                mergeConfirmedActions,
                                                                                confirmedAction,
                                                                                availableActions
                                                                            }) => {
    const selectedOption = React.useMemo(() => {
        return isMixedActionSelected
            ? getSuggestedOption(translatedActionsEnum, ActionsEnum.MULTIPLE_SELECTIONS)
            : getSuggestedOption(translatedActionsEnum, confirmedAction?.action);
    }, [translatedActionsEnum, suggestedAction, isMixedActionSelected, confirmedAction]);

    const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e?.preventDefault();
        e?.stopPropagation();
    };

    const handleOnChange = (value: SelectInputOption, actionMeta: any) => {
        const action = {...confirmedAction, action: value.value as ActionsEnum};
        mergeConfirmedActions(action, isMixedActionSelected);
    };

    return (
        <Div onClick={stopPropagation}>
            <SelectInput
                name={`suggested-action-${confirmedAction?.status}-${confirmedAction?.statusDetail}`}
                options={getActionOptions(
                    translatedActionsEnum,
                    availableActions,
                    isMixedActionSelected,
                )}
                defaultValue={selectedOption}
                value={selectedOption}
                size={"small"}
                label={AppTranslations.massiveActions.censusCooler.actionToApply}
                styles={{input: {height: "37px", width: "250px"}}}
                onChange={handleOnChange}
            />
        </Div>
    );
};
